import { render, staticRenderFns } from "./OnLineFirstArticle.vue?vue&type=template&id=ac1ba8ec&scoped=true"
import script from "./OnLineFirstArticle.vue?vue&type=script&lang=js"
export * from "./OnLineFirstArticle.vue?vue&type=script&lang=js"
import style0 from "./OnLineFirstArticle.vue?vue&type=style&index=0&id=ac1ba8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1ba8ec",
  null
  
)

export default component.exports